import { memo } from 'react';

type HtmlStyleResourcesProps = {
  cssPayload: string;
  nonce: string | undefined;
};

function HtmlStyleResources({ cssPayload, nonce }: HtmlStyleResourcesProps) {
  if (!cssPayload?.trim()) return null;

  return (
    <div
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: cssPayload }}
    />
  );
}

export default memo(HtmlStyleResources);
